module.exports = __webpack_public_path__ + "static/media/learning-history.884d9384.svg";